import { ActionTypes } from "../../constants/ActionTypes";
import { IUserConfigReducer } from "../../interfaces/UserConfig";

const INIT_STATE: IUserConfigReducer = {
  pwaUserConfig: {
    pwaTheme: "",
    lang: "",
  },
  waiteToSet: false,
  getThemeColor: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_PWA_USER_CONFIG: {
      return {
        ...state,
        getThemeColor: true,
      };
    }

    case ActionTypes.FETCH_PWA_USER_CONFIG_SUCCESS: {
      localStorage.setItem("pwaTheme", action.payload.pwaTheme);
      localStorage.setItem("language", action.payload.lang);
      let prevState = { ...state } as IUserConfigReducer;

      prevState.pwaUserConfig = {
        lang: action.payload.lang,
        pwaTheme: action.payload.pwaTheme,
      };

      return {
        ...prevState,
      };
    }

    case ActionTypes.SET_USER_CONFIG: {
      return {
        ...state,
        pwaUserConfig: action.payload,
        waiteToSet: true,
      };
    }

    case ActionTypes.SET_USER_CONFIG_SUCCESS: {
      return {
        ...state,
        waiteToSet: false,
      };
    }
    default:
      return state;
  }
};
